import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import SortNav from "../../../components/SortNav";

const InsuranceCertificateAddition = (props) => {
  const { certificates, insurance, dispatch } = props;
  /*   const _resource = useSelector(state => state["resources_data"].patchResource);
    const [localResources, setLocalResources] = useState(resources);
    const [resourcePending, setResourcePending] = useState(null);
    useEffect(() =>{
        if(resourcePending === null || _resource.success === "") return;
        setResourcePending(null);
    },[_resource]);
    const getStatusSelect = (resource) => {
        let status = resource.status;
        return [
            {text: t('active',null,'capital'), value: 'active', disabled: "", selected: (status==='active')},
            {text: t('inactive',null,'capital'), value: 'inactive', disabled: "", selected: (status==='inactive')},
            {text: t('defect',null,'capital'), value: 'defect', disabled: "", selected: (status==='defect')}
        ];
    };

    const setStatus = (e,resource,index) => {
        let clone = localResources;
       // Object.assign(clone,localResources);
        resources[index].status = e.target.value;
        //setLocalResources(clone);
        dispatch(resourcesActions.patchResource({
                token: Biscuit.get('token'),
                resource_id: resource.id,
                data: {
                    status: e.target.value
                }
            }
        ));
        setResourcePending(index);
    }*/
  let tabs = [
    {
      name: t("number", null, "capital"),
      smallWidth: 2,
      mediumWidth: 1,
      title: t("number", null, "capital"),
      canSort: false,
    },
    {
      name: t("certificate", null, "capital"),
      smallWidth: 4,
      mediumWidth: 2,
      title: t("certificate", null, "capital"),
      canSort: false,
    },
    {
      name: t("subscription", null, "capital"),
      mediumWidth: 1,
      smallWidth: 2,
      title: t("subscription", null, "capital"),
      canSort: false,
    },
    {
      name: t("cancel_before_next_cycle", null, "capital"),
      smallWidth: 2,
      mediumWidth: 1,
      title: t("cancel_before_next_cycle", null, "capital"),
      canSort: false,
    },
    {
      name: t("price", null, "capital"),
      smallWidth: 2,
      mediumWidth: 1,
      title: t("price", null, "capital"),
      canSort: false,
    },
    {
      name: t("frame_nbr", null, "capital"),
      smallWidth: 4,
      mediumWidth: 2,
      title: t("frame_nbr", null, "capital"),
      canSort: false,
    },
    {
      name: t("uvp", null, "capital"),
      smallWidth: 2,
      mediumWidth: 1,
      title: t("uvp", null, "capital"),
      canSort: false,
    },
  ];

  return (
    <>
      <header className="inb-c-item-details__header small-12 column">
        <SortNav tabs={tabs} listStyle="tight" autoHeight={true} />
      </header>

      {certificates.map((certificate, index) => {
        console.log(index + 1 + " Zertifikat", certificate);
        return (
          <>
            <div
              className="inb-certificate inb-c-item-details-row row padding-left-10"
              data-inb-certificate-id={certificate.id}
              data-inb-context="insurance_certificates"
              style={{ paddingLeft: "10px" }}
            >
              <div className="medium-1 small-2 column inb-certificate__id">#{index + 1}</div>
              <div className="medium-2 small-2 column inb-certificate__certificate">
                {certificate.certificate}
              </div>
              <div className="medium-1 small-2 column inb-certificate__subscription">
                {certificate.subscription}
              </div>
              <div className="medium-1 small-2 column inb-certificate__cancel_before_next_cycle">
                {certificate.cancel_before_next_cycle}
              </div>
              <div className="medium-1 small-2 column inb-certificate__price">
                {certificate.price}
              </div>
              <div className="medium-2 small-4 column inb-certificate__resource_id">
                {certificate.frame_nbr}
              </div>
              <div className="medium-1 small-2 column inb-certificate__product_id">
                {certificate.uvp}
              </div>
            </div>
          </>
        );
      })}
    </>
  );
};
export default InsuranceCertificateAddition;
